import { defineStore } from "pinia";
import { createFleetState, fleetGetters } from "./assignment.state";
import { fleetSyncActions, fleetAssignmentActions, } from "./assignment.actions";
export { assignVehiclesToServices, assignVehiclesFromAracIds, servicesHaveAracIds, } from "./assignVehicles.algorithm";
/**
 * Filo optimizasyonu araç atama state (Pinia).
 * Vuex kaynak: `store/modules/vehicleAssignment.js` — FAZ 6 migration.
 * micro-6S-13: modüller `stores/fleet/` altında; davranış birebir.
 *
 * State anahtarları (vehicleAssignment.js birebir):
 * - vehicles — atanan araç listesi
 * - assignments — sefer–araç eşleşmeleri
 * - parkurSureleri — { gidis, donus } parkur süreleri
 * - originalParkurSureleri — API'den gelen orijinal parkur süreleri
 */
export const useFleetStore = defineStore("fleet", {
    state: () => createFleetState(),
    getters: fleetGetters,
    actions: {
        ...fleetSyncActions,
        ...fleetAssignmentActions,
    },
});
